import React from 'react';
import { ArrowRight } from 'lucide-react';
type Props = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
};

/** ClickFunnels-style primary CTA: gold, heavy, with a pressed bottom edge. */
export function BuyButton({
  children,
  href = '#compra',
  onClick
}: Props) {
  const external = href.startsWith('http');
  return <a href={href} onClick={onClick} target={external ? '_top' : undefined} className="cta-pulse group flex w-full items-center justify-center gap-2 rounded-xl border-b-[5px] border-gold-dark bg-gold px-5 py-4 text-center text-base font-black uppercase leading-tight tracking-tight text-brand-dark shadow-[0_10px_24px_-10px_rgba(18,76,56,0.55)] transition-[transform,background-color,border-width] duration-150 ease-out hover:bg-[#e4b94d] active:translate-y-[3px] active:border-b-2 sm:text-lg md:mx-auto md:max-w-xl" data-id="element-0" data-mp="bunr8f0s30id">
      <span data-id="element-1" data-mp="1n914kpxwnxk5">{children}</span>
      <ArrowRight className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={3} data-id="element-2" data-mp="1nacez8luw3k8" />
    </a>;
}